<template>
  <div class="product__bundle-options small-24">
    <span class="title">{{ bundleOption.title }} <em v-if="bundleOption.required">*</em></span>
    <ul>
      <li v-for="(selection, i) in sortedSelections">
        <input :disabled="!selection.is_saleable" :id="selection.product_id" @change="updateProduct($event, i)" type="checkbox" :name="`bundle_option[${bundleOption.option_id}][${selection.product_id}]`" :value="selection.selection_id">
        <label :for="selection.product_id">
          1x {{ selection.name }}
          <strong v-if="selection.price > 0">(+{{ selection.price.priceFormat() }})</strong>
        </label>
        <span class="selection__not-in-stock" v-if="!selection.is_saleable">{{ $t('Not in stock') }}</span>
      </li>
    </ul>
    <input type="hidden" :name="`bundle_option_qty[${bundleOption.option_id}]`" value="1">
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-bundle-checkbox'
    }
  )

  export default class extends Vue {
    @Prop() private readonly bundleOption: object;

    private get sortedSelections(): object {
      return Object.values(this.bundleOption['selections']).sort((a, b) => (a['price'] > b['price']) ? 1 : -1);
    }

    private updateProduct(e, i): void {
      this.$store.dispatch('CatalogBundleProduct/updateSelectedOption',
        Object.assign(this.sortedSelections[i], {qty: e.target.checked ? 1 : 0, option_id: this.bundleOption['option_id']})
      );
    }
  }
</script>
